import Modal from 'react-native-modal';
import { BasicModalWithTwoButtons } from '../Modal/BasicModalWithTwoButtons';
import { logAmplitude } from '../../utils/analytics/analytics';
import { useStores } from '../../hooks/useStores';

export type ModalChallengeProps = {
 modalVisible: boolean;
 setModalVisible: (visible: boolean) => void;
 exerciseId: string;
}

export const ModalChallenge = ({modalVisible, setModalVisible, exerciseId}: ModalChallengeProps) => {
  const rootStore = useStores();


  const exercise = rootStore?.exercise?.getExercise(exerciseId);
  const labels = rootStore?.language?.translate?.MOBILE?.STEP_ACTION;

  const onPressFinish = () => {
    if (exercise.myExerciceId) {
      rootStore?.exercise.discardExercise(exercise._id);
    }
    logAmplitude('Exercice Completed', {
      contentId: exercise?.humanReadableId,
      contentName: exercise?.title,
    });

  };
  return(
    <Modal isVisible={modalVisible}   >
      <BasicModalWithTwoButtons  mainText={labels?.MODAL?.MAIN_TEXT}
        onDismiss={() => {setModalVisible(false);}}
        buttonMainActionText={labels?.MODAL?.BUTTON_RIGHT}
        onMainAction={() => {
          onPressFinish();
          setModalVisible(false);
        }}
        buttonDismissText={labels?.MODAL?.BUTTON_LEFT}
        titleText={labels?.MODAL?.TITLE.replace('{{name}}', rootStore?.user?.user?.name)}/>
    </Modal>);
};